import React, { Fragment, Suspense, useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { base_url } from "./Constants";
import { fetchSettingData } from "../redux/stateSlice/settingDataSlice";
import axios from "axios";
const BlogView = React.lazy(() => import("../components/BlogView"));
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const Blog = () => {
  const {t, i18n} =  useTranslation();
  const  {data,loading,error} =  useSelector(state=>state.settingData);
  const dispatch =  useDispatch();
  const [items,setItems] = useState([]);
  const [current_page,setCurrentPage] =  useState(1);
  const [page_no,setPageNo] =  useState(1);
 
  
  useEffect(()=>{
    if (!data && !loading) {
      dispatch(fetchSettingData());
    }
  },[data, loading, dispatch])
  return (
    <>
    {data&&(
      <Fragment>
        {loading?(
          <Preloader />
        ):(
          <Suspense fallback={<Preloader />}>
            {/* Search Popup */}
            <SearchPopup />

            {/* Navbar One */}
            <NavbarOne title={t('blog')}  og_image={base_url+'/'+data.blog_bg} />

            {/* Breadcrumb */}
            <Breadcrumb title={t('blog')} header_bg={base_url+'/'+data.blog_bg} />

            {/* Blog View */}
            <BlogView />

            {/* Footer One */}
            <FooterOne />

            {/* Footer Bottom One */}
            <FooterBottomOne />
          </Suspense>
        )}
      </Fragment>
    )}
      
    </>
  );
};

export default Blog;
